import { Stack, TextField } from '@mui/material';

import { IconSelectorInput } from '@@common';

import { TabModel } from '../../Models/TabModel';
import { SortableCollapsibleItem } from './SortableCollapsibleItem';
import { SortableItemListDialog } from './SortableItemListDialog';

// ---- Tab item editor ----

type TabEditorProps = {
	tab: TabModel;
	onChange: (updated: TabModel) => void;
};

function TabEditor({ tab, onChange }: TabEditorProps) {
	return (
		<Stack spacing={2}>
			<TextField label="Label" value={tab.Label} onChange={(e) => onChange({ ...tab, Label: e.target.value })} size="small" required fullWidth />
			<IconSelectorInput value={tab.IconName} onValueChange={(value) => onChange({ ...tab, IconName: value })} label="Icon Name" variant="standard" />
		</Stack>
	);
}

// ---- Dialog ----

type TabsItemsInputDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	tabs: TabModel[] | undefined;
	onTabsChange: (tabs: TabModel[]) => void;
};

export function TabsItemsInputDialog({ open, setOpen, tabs, onTabsChange }: TabsItemsInputDialogProps) {
	return (
		<SortableItemListDialog
			open={open}
			setOpen={setOpen}
			title="Configure Tabs"
			items={tabs}
			onItemsChange={onTabsChange}
			createItem={() => ({ Label: 'Tab' }) as TabModel}
			addLabel="Add Tab"
		>
			{(tab, index, total, onChange, onMoveUp, onMoveDown, onDelete) => (
				<SortableCollapsibleItem
					key={index}
					title={tab.Label || `Tab ${index + 1}`}
					subtitle={tab.IconName}
					index={index}
					total={total}
					onMoveUp={onMoveUp}
					onMoveDown={onMoveDown}
					onDelete={onDelete}
				>
					<TabEditor tab={tab} onChange={onChange} />
				</SortableCollapsibleItem>
			)}
		</SortableItemListDialog>
	);
}
